<kendo-window #chatWindow class="chat-window" title="{{'CHAT' | translate}}" *ngIf="(isLoggedIn | async) && isVisible"
    (close)="close()" [top]="getTop()" [left]="getLeft()" [width]="getWidth()" [height]="getHeight()"
    [state]="getState()" (stateChange)="stateChanged($event)" (dragEnd)="dragEnd()" (topChange)="topChanged($event)"
    (leftChange)="leftChanged($event)" (heightChange)="heightChanged($event)" (widthChange)="widthChanged($event)"
    style="min-height:62px;">
    <kendo-window-titlebar>
        <div class="k-window-title">
            <h3 class="ellipsis-text">
                <i class="fal fa-comment-alt-lines fa-fw"></i>
                {{ 'CHAT' | translate }}
            </h3>
        </div>
        <button attr.aria-label="{{'MINIMIZE' | translate}}" kendoWindowMinimizeAction></button>
        <button attr.aria-label="{{'MAXIMIZE' | translate}}" kendoWindowMaximizeAction></button>
        <button attr.aria-label="{{'RESTORE' | translate}}" kendoWindowRestoreAction></button>
        <button attr.aria-label="{{'CLOSE' | translate}}" kendoWindowCloseAction></button>
    </kendo-window-titlebar>
    <app-chat-list [isWindow]="true" [windowHeight]="windowHeight"></app-chat-list>
</kendo-window>